import React from "react";

const Switzerland = () => {
  return (
    <svg
      fill="none"
      height="15"
      viewBox="0 0 20 15"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        height="15"
        id="mask0_305_22320"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
        width="20"
        x="0"
        y="0"
      >
        <rect fill="white" height="15" width="20" />
      </mask>
      <g mask="url(#mask0_305_22320)">
        <path
          clipRule="evenodd"
          d="M0 0V15H20V0H0Z"
          fill="#E31D1C"
          fillRule="evenodd"
        />
        <mask
          height="15"
          id="mask1_305_22320"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "alpha" }}
          width="20"
          x="0"
          y="0"
        >
          <path
            clipRule="evenodd"
            d="M0 0V15H20V0H0Z"
            fill="white"
            fillRule="evenodd"
          />
        </mask>
        <g mask="url(#mask1_305_22320)">
          <path
            clipRule="evenodd"
            d="M11.25 3.75H8.75V6.25H6.25V8.75H8.75V11.25H11.25V8.75H13.75V6.25H11.25V3.75Z"
            fill="#F1F9FF"
            fillRule="evenodd"
          />
        </g>
      </g>
    </svg>
  );
};

export default Switzerland;
